import styled from '@emotion/styled';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { mainColors } from 'src/assets/colors';

export const ContentH2 = styled('h2', { label: 'ContentH2' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.medium};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin: 8px 0;
`;

export const ContentH3 = styled('h3', { label: 'ContentH3' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xMedium};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin: 12px 0;
`;

export const ContentH4 = styled('h4', { label: 'ContentH4' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.regular};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin: 8px 0;
`;

export const ContentH5 = styled('h5', { label: 'ContentH5' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin: 8px 0;
`;

export const ParagraphSmall = styled('p', { label: 'ParagraphSmall' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.regular};
    line-height: 1.3334;
    margin: 0;
`;

export const ParagraphDefault = styled('p', { label: 'ParagraphDefault' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.regular};
    line-height: 1.3334;
    margin: 0;
`;

export const Label = styled('p', { label: 'Label' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.medium};
    line-height: 1.33;
    color: ${mainColors.default.dark};
    margin: 0 0 4px 0;
    user-select: none;
`;
